import React, { Fragment, useEffect, useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useRealtimeTags } from 'Core/hooks';
import { InputSearch, Select, Button, Tooltip } from 'Components';
import { Grid, Typography, Icon, LinearProgress } from '@mui/material';
import { Checkbox } from 'Components/uiControls';
import { injectIntl } from 'react-intl';
import { endpoints } from 'Core/defaultValues';
import { MenuComponent } from 'Components/Menu';
import useExport from 'Components/Table/Export';
import { ExportButton } from 'Components/TableView/Toolbar';
import { OrderData } from 'Core/data/Helpers';
import _ from 'lodash';
import { GeofenceRadiusValues, TypeLayer } from '../../../../../../../components/Map/providers/enums';
import InfiniteScroll from "react-infinite-scroll-component";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { TagsGroup } from 'Components/Tag';
import styles from 'Assets/sass/core/vars.scss';
import { getTagsIdsArray } from 'Components/Map/utils';
import './style.scss'


//Views
import Contacts from '../geofenceContacts';
import Delete from '../geofenceDelete';
import GeofenceAssign from '../geofenceAssign';
import GeofenceBulk from '../geofenceBulk';

/*********************************************************
* Globals
*********************************************************/
const LIMIT_PAGE = 10;

/*********************************************************
 * Actions
*********************************************************/
import {
    mapGeofencesOpenEditCreateModal,
    mapGeofencesOpenContactsModal,
    mapGeofencesOpenCloseAssignModal,
    mapGeofenceOpenDeleteModal,
    mapGeofenceBulkOpenModal,
    getLandmarksAndGeofences as getKmls
} from 'Redux/actions';

const GeofenceSettingsViewGeo = (props) => {
    const { intl, mapRef } = props;
    const { messages } = intl;

    //list of menus
    const landmarkActions = [
        messages['map_landmark_edit'],
        messages['map_landmark_delete']
    ];

    const untaggedObject = {
        id: 0,
        name: messages['untagged'],
        color: styles.color_untagged,
        visible: true,
        open: false,
        items: []
    }

    /*********************************************************
     * States
    *********************************************************/

    const dispatch = useDispatch();

    const [filter, setFilter] = useState('');
    const [group, setGroup] = useState();
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [checkSelectAll, setCheckSelectAll] = useState(false); //Default unselected all
    const [selectedRow, setSelectedRow] = useState();
    const [selectedRows, setSelectedRows] = useState([]);
    const [unselectedRows, setUnselectedRows] = useState([]);
    const [exportData, setExportData] = useState([])

    /*********************************************************
     * Use selector
    *********************************************************/
    const { geofenceTags, geofenceTagsLoading } = useSelector((state) => state.realtimeMapNewGeofenceModuleRedux);
    const jsonGeofence = useSelector((state) => state.catalogsRealtimeRedux.geofences);
    const loadingGeofenceJson = useSelector((state) => state.catalogsRealtimeRedux.loadingGeofences);
    const { open: openGeofenceBulk } = useSelector((state) => state.realtimeMapGeofenceBulkModuleRedux);
    const { user: { isKph }, user } = useSelector((state) => state.securityRedux);

    const tags  = useRealtimeTags({ trackFields: ['id', 'label', 'disabled', 'tagPath', 'tags', 'color', 'parentId'] });
    const haveUntagged = !!(
        (jsonGeofence && Array.isArray(jsonGeofence) && jsonGeofence.some(item => {
            const tagsIds = getTagsIdsArray(item.tagsId);
            return (tagsIds.includes('-1') || tagsIds.length === 0);
        })) ||
        (tags && Array.isArray(tags) && tags.some(tag => tag.id === -1)) ||
        (!tags || tags.length === 0)
    );

    const {
        open: openContacts
    } = useSelector((state) => state.realtimeMapGeofenceContactsRedux);

    const {
        open: openAssign
    } = useSelector((state) => state.realtimeMapGeofenceAssignRedux);

    /*********************************************************
     * Set the groups preferences
    *********************************************************/
    useEffect(() => {
        getAllGeofences()
    }, [geofenceTags])

    /*********************************************************
     * Set the landmarks by rows per page in start data
    *********************************************************/
    useEffect(() => {
        if (group && jsonGeofence && jsonGeofence.length > 0) {
            restartView();
        } else {
            getAllGeofences()
        }
    }, [group, jsonGeofence])


    /*********************************************************
     * Set all geofences to export data
    *********************************************************/
    useEffect(() => {
        if(geofenceTags?.length && !loadingGeofenceJson) setExportData(getAllGeofences())
    }, [geofenceTags, loadingGeofenceJson])

    /*********************************************************
     * Start to get all landmarks into the view
    *********************************************************/
    const getAllGeofences = () => {
        let newGeofences = [];
        if (geofenceTags && geofenceTags.length > 0 && !group) {
            if (haveUntagged) {
                newGeofences = OrderData(jsonGeofence, 'name');
            } else {
                //only groups to enable this user
                geofenceTags.forEach((tag) => {
                    newGeofences = [
                        ...newGeofences,
                        ...jsonGeofence.filter((item) => {
                            if (item.tagsId) {
                                const tagsIds = item.tagsId.split(',')
                                return tagsIds.includes(tag.id.toString())
                            }
                            return false;
                        })
                    ];
                })
                newGeofences = OrderData(newGeofences, 'name');
            }
            const toSetData = [...newGeofences]
            setData(toSetData.slice(0, page * LIMIT_PAGE));
        }else if(haveUntagged){
            newGeofences = OrderData(jsonGeofence, 'name');
            const toSetData = [...newGeofences]
            setData(toSetData.slice(0, page * LIMIT_PAGE));
        }
        return newGeofences;
    }

    /*********************************************************
     * Restart the elements into the view
    *********************************************************/
    const restartView = () => {
        setSelectedRows([]);
        setSelectedRow(null);
        setPage(1); //start page count
        getItemsGeofence(1);
        setCheckSelectAll(false);
        setUnselectedRows([]);
    }

    /*********************************************************
     * Draw the geofences into the map
    *********************************************************/
    const getAllFilteredGeofences = () => {
        let filteredGeofences = []
        if (group && group.length > 0 && jsonGeofence && jsonGeofence.length > 0) {
            group.forEach((tag) => {
                filteredGeofences = [
                    ...filteredGeofences,
                    ...jsonGeofence.filter((item) => {
                        if (item?.tagsId && item?.tagsId != "-1") {
                            const tagsIds = item.tagsId.split(',')
                            return tagsIds.includes(tag.id.toString())
                        } else if (haveUntagged && tag.id == 0) {
                            return (item.tagsIds == null)
                        }
                        return false;
                    })
                ];
            })
        } else {
            if (haveUntagged) {
                filteredGeofences = [...jsonGeofence];
            } else {
                filteredGeofences = [...getAllGeofences()]
            }
        }
        return OrderData(filteredGeofences, 'name');
    }

    const getItemsGeofence = (newPage = 0) => {
        let filteredGeofences = []
        if (group && group.length > 0 && jsonGeofence && jsonGeofence.length > 0) {
            group.forEach((tag) => {
                //tag.id
                filteredGeofences = [
                    ...filteredGeofences,
                    ...jsonGeofence.filter((item) => {
                        if (item?.tagsId && item?.tagsId != "-1") {
                            const tagsIds = item.tagsId.split(',')
                            return tagsIds.includes(tag.id.toString())
                        } else if (haveUntagged && tag.id == 0) {
                            return (item.tagsIds == null)
                        }
                        return false;
                    })
                ];
            })
        } else {
            if (haveUntagged) {
                filteredGeofences = [...filteredGeofences, ...jsonGeofence];
            } else {
                //filter the tags by user permissions
                filteredGeofences = [...getAllGeofences()]
            }
        }

        let newGeofences = OrderData(filteredGeofences, 'name');
        setData(newGeofences.slice(0, (newPage > 0 ? newPage : page) * LIMIT_PAGE));

        if (checkSelectAll) {
            setSelectedRows(filteredGeofences);
        }

    }

    /*********************************************************
     * set the new page from event infinite scroll
    *********************************************************/
    const setNoPage = (page) => {
        setPage(page);
        getItemsGeofence(page);
    }

    /*********************************************************
     * get information from text component in view. filter the elements
    *********************************************************/
    const onSearch = useCallback((value) => {
        setFilter(value);

        if (window.typingTime) {
            clearTimeout(window.typingTime);
        }

        if (!value) {
            setPage(1); //start page count
            getItemsGeofence(1);
            setCheckSelectAll(false);
            return;
        }

        if (checkSelectAll) {
            setCheckSelectAll(false);
            setSelectedRows([]);
        }

        if (group) {
            setGroup()
        }

        window.typingTime = setTimeout(() => {
            let idsForGroups = []
            if (geofenceTags && geofenceTags.length > 0) {
                idsForGroups = geofenceTags.map((item) => parseInt(item.id))
            }
            const newFilter = jsonGeofence.filter((item) =>
                value &&
                validateIncludes(item, idsForGroups)
                &&
                item.name.toLowerCase().includes(value.toLowerCase()))

            let formatData = formatTimeHour(newFilter);
            setData(formatData);
            window.typingTime = null;
        }, 1000);
    });

    /*********************************************************
     * Validate include ids in array
    *********************************************************/
    const validateIncludes = (geofences, idsForGroups) => {
        let valueReturn = false
        if (geofences.tagsId && geofences?.tagsId != "-1") {
            const tagsIds = geofences.tagsId.split(',')
            idsForGroups.forEach((tagId) => {
                if (tagsIds.includes(tagId.toString())) {
                    valueReturn = true;
                }
            })
        } else if (haveUntagged) {
            //Untagged geofences
            valueReturn = true
        }

        return valueReturn
    }

    /*********************************************************
     * Get the icon url from Geofence or Geofence Tags
    *********************************************************/
    const getIconGeofence = useCallback((geofence) => {
        let geofenceGroup = null
        if (geofence.tagsId == 0) {
            geofenceGroup = []
        } else {
            geofenceGroup = geofenceTags.find((item) => item.id == geofence.tagsId)
        }

        let geofenceColor = geofence.color ? geofence.color : geofenceGroup?.color || '8677D9'
        return geofenceColor
    })

    /*********************************************************
     * Select the card into the table
    *********************************************************/
    const onSelectCard = (row) => {
        if (row?.id == selectedRow?.id) {
            setSelectedRow(null);
        } else {
            setSelectedRow(row);
            findGeofenceOnMap(row);
        }
    }

    const getCenterForGeofence = (item) => {
        let centerToGeofence;

        if(item?.center_latlong){
            const arrayLatLng = item?.center_latlong.split(',');
            centerToGeofence = [{ lat: parseFloat(arrayLatLng[0]), lng: parseFloat(arrayLatLng[1]) }]
        }else{
            const { coordinates } = item;
            const coordinatesFormat = coordinates.map((item) => { return { latitude: parseFloat(item.latitude), longitude: parseFloat(item.longitude) } });
            centerToGeofence = [{ lat: coordinatesFormat[0].latitude, lng: coordinatesFormat[0].longitude }];
        }
        return centerToGeofence;
    }

    /*********************************************************
     * Draw the landmarks into the map
    *********************************************************/
    const findGeofenceOnMap = (item) => {
        const isInfoBubbleOpened = mapRef?.current?.getOpenInfoWindow();
        if (!_.isEqual(selectedRow, item) || !isInfoBubbleOpened) {
            const { coordinates } = item
            const coordinatesFormat = coordinates.map((item) => { return { latitude: parseFloat(item.latitude), longitude: parseFloat(item.longitude) } })
            const radius = item.radius > 0 ? item.radius : 0
            const coordinatesCenter = radius > 0 ? getCenterForGeofence(item) : coordinatesFormat
            const center = mapRef.current.centerByFitBounds(coordinatesCenter, radius)
            if (!center) return
            const mapObject = {
                id: item?.id,
                position: center,
                label: item?.name,
                icon: {
                    rotation: 0
                },
                layerName: TypeLayer.Geofence
            }
            mapRef.current.modalPopupEvent(mapObject, mapObject);

            //Always show the landmark on map
            mapRef.current.removeLayer(TypeLayer.TemporalObjects);
            mapRef.current.drawLandmark({ ...item, hideMarker: true }, radius, coordinatesCenter, true)
        }
    }

    /********************************************************
     * Define the columns to export data
     ********************************************************/
    const getHeaders = () => {
        return [
            messages["mapGeofenceSettings_geofence_title"],
            messages["mapGeofenceSettings_geofence_radius"],
            messages["mapGeofenceSettings_geofence_groups"],
            messages["mapGeofenceSettings_geofence_alerton"]];
    }

    /********************************************************
     * Get data to generate files PDF or CSV
     ********************************************************/
    const getDataToExport = (rows) => {
        let items = rows ? rows : [];
        let data = [];

        //Filter export by selection
        if (selectedRows && selectedRows.length > 0) {
            const onlyIds = selectedRows.map(item => item.id)
            items = items.map((element) => {
                if (onlyIds.includes(element.id))
                    return element
                return null
            })
            items = items.filter(item => item)
        }

        items.forEach((item) => {
            const title = item.name;

            const valueRadius = item?.radius
            let geofenceRadius = GeofenceRadiusValues.find(value => value.value == valueRadius)?.text;
            geofenceRadius = geofenceRadius ? geofenceRadius : `${isKph ? parseFloat(valueRadius * 0.001).toFixed(2) : parseFloat(valueRadius * 0.000621371).toFixed(2)} ${isKph ? messages['kilometers'] : messages['miles']}`;

            const radius = valueRadius > 0 ? `${geofenceRadius}` : '';
            const groups = getTagName(item.tagsId);
            const alertType = item?.alertOnType;

            data.push([title, radius, groups, alertType]);
        });

        return data;
    }

    /********************************************************
     * Get the tag name value
     ********************************************************/
    const getTagName = (tagsId) => {
        let stringNameTags = '';
        if (tagsId) {
            const tagsIds = tagsId.split(',')
            geofenceTags.forEach((tagId) => {
                if (tagsIds.includes(tagId.id.toString()))
                    stringNameTags = stringNameTags + tagId.name + ', ';
            })
            stringNameTags = stringNameTags.slice(0, -2)
        }

        return stringNameTags;
    }

    /********************************************************
     * Use hook to export PDF
     ********************************************************/
    const exportCSVPdf = useExport(
        getHeaders,
        getDataToExport,
        [],
        exportData.length ? exportData : [],
        null,
        messages['mapGeofenceSettings_geofence_export'],
        null,
        true
    );

    /*********************************************************
     * Options to export data (Button)
    *********************************************************/
    const onExport = (item) => {
        if (item === 'CSV') {
            exportCSVPdf.exportCSV();
        } else if (item === 'PDF') {
            exportCSVPdf.exportPDF();
        }
    }

    const formatTimeHour = (insideDurationTime) => {

        let result = [];
        insideDurationTime.forEach((insideDuration) => {
            let data = '';
            if (insideDuration?.insideDurationMins !== 0) {
                let hoursCalc = Math.floor(insideDuration?.insideDurationMins / 60);
                let minutesCalc = insideDuration?.insideDurationMins % 60;
                let hours = (hoursCalc > 0) ? `${hoursCalc}h` : '';
                let minutes = (minutesCalc > 0) ? `${minutesCalc}min` : '';
                data = `${hours} ${minutes}`;
            }
            result.push({
                ...insideDuration,
                insideDurationFormat: data
            })
        });

        return result;
    }

    /*********************************************************
     * Count the contacts from array
    *********************************************************/
    const onCountContacts = (value = '') => {
        if (value && !Array.isArray(value)) {
            const arrayContactsId = value.split(',');
            if (arrayContactsId && arrayContactsId.length > 0) {
                return arrayContactsId.length
            }
        } else if (value && Array.isArray(value)) {
            return value.length
        }
        return 0
    }

    /*********************************************************
     * Selected all items in grid view
    *********************************************************/
    const selectAllRows = (checked, data) => {
        if (checked) {
            const filter = data
            setSelectedRows(filter);
        } else {
            setSelectedRows([]);
        }
        setCheckSelectAll(checked);
    }

    /*********************************************************
     * Check new element into the list
    *********************************************************/
    const selectRow = (row, value) => {

        let newSelectedRows = [];
        if (value) {
            newSelectedRows = [...selectedRows];
            newSelectedRows.push(row);
        } else {
            newSelectedRows = selectedRows.filter(selectedRow => selectedRow.id !== row.id);
        }

        setSelectedRows([...newSelectedRows]);

        if(checkSelectAll){
            let unselectedData = [...unselectedRows]
            if(value){ //if true remove from the list
                unselectedData = unselectedData.filter(unselected => unselected.id !== row.id);
            }else{
                //add the item into the list
                unselectedData.push(row)
            }
            setUnselectedRows(unselectedData)
        }

    }

    const cleanSearch = () => {
        setSelectedRow(null);
        setSelectedRows([]);
        setGroup()
    }

    /*********************************************************
     * Convert tags to array
    *********************************************************/
    const convertTagStringToArray = (geofences) => {
        let tagsListFinal = []
        if (geofences.tagsId) {
            const tagsIds = geofences.tagsId.split(',')
            tagsIds.forEach((tagId) => {
                const newTagElement = geofenceTags.find((element) => element.id == parseInt(tagId))
                if (newTagElement) {
                    tagsListFinal.push({ ...newTagElement, color: newTagElement?.color || "#000000" });
                }

            })

            return tagsListFinal
        } else if (geofences?.tags) {
            return geofences?.tags;
        } else if (haveUntagged) {
            tagsListFinal.push(untaggedObject);
        }

        return tagsListFinal;
    }

    /*********************************************************
     * Add the list with untagged groups
    *********************************************************/
    const getTags = () => {
        if (haveUntagged) {
            let tagItems = [];
            tagItems = [...tagItems, ...(geofenceTags || [])];
            tagItems = tagItems ? OrderData(tagItems, "name") : [];
            tagItems.unshift(untaggedObject)

            return tagItems;
        }

        return geofenceTags ? OrderData(geofenceTags, "name") : [];
    }

    return (
        <div>
            <Grid container spacing={0}>
                <Grid item sm={12}>
                    <InputSearch
                        searchText={filter}
                        onSearch={(param) => onSearch(param)}
                    />
                </Grid>

                <Grid item sm={12} style={{ marginBottom: 8 }}>
                    <Select
                        label={''}
                        placeholder={messages['maputilities_visible_filterByTags']}
                        value={group}
                        onChange={(event) => {
                            setGroup(event);
                            setSelectedRow(null);
                            setSelectedRows([]);
                        }}
                        id="id"
                        className="react-select-landmark"
                        options={getTags()}
                        textField={'name'}
                        valueField={'id'}
                        required
                        disabled={geofenceTagsLoading || filter}
                        multiple
                    />
                </Grid>
            </Grid>

            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                style={{ paddingTop: 10 }}
            >
                <Grid item
                    style={{
                        paddingTop: 1
                    }}
                >
                    <Checkbox
                        id={'-selectAll'}
                        value={(data.length && data.length === selectedRows.length) ? true : false}
                        partiallySelected={(selectedRows.length > 0 && selectedRows.length < data?.length) ? true : false}
                        size="md"
                        onChange={(checked) => {
                            selectAllRows(checked, data);
                        }}
                    />
                </Grid>

                <Grid item>
                    <Button
                        type="icon"
                        icon="add_box"
                        tooltip={messages['add']}
                        size="medium"
                        fontSize="inherit"
                        onClick={() => {
                            dispatch(mapGeofencesOpenEditCreateModal(true));
                            setFilter('');
                        }}
                    />
                </Grid>

                <Grid item>
                    <ExportButton
                        onExport={onExport}
                        className='landmark-icon-download'
                        size="medium"
                        fontSize="inherit"
                    />
                </Grid>

                <Grid item>
                    {
                        selectedRows.length > 0 &&
                        <Button
                            type="icon"
                            icon="delete"
                            tooltip={messages['delete']}
                            disabled={!selectedRows.length}
                            size="medium"
                            fontSize="inherit"
                            onClick={() => {
                                const hasGroupFilter = checkSelectAll && group && group.length > 0;
                                let geofencesToDelete = selectedRows;
                                let isDeleteAll = checkSelectAll && !hasGroupFilter;
                                let filterTagsToPass = null;

                                if (hasGroupFilter) {
                                    const allFiltered = getAllFilteredGeofences();
                                    geofencesToDelete = allFiltered.filter(
                                        (g) => !unselectedRows.find((u) => u.id === g.id)
                                    );
                                    filterTagsToPass = group;
                                }

                                dispatch(mapGeofenceOpenDeleteModal(true, geofencesToDelete, isDeleteAll, unselectedRows, filterTagsToPass));
                                setSelectedRows([]);
                                selectAllRows(false);
                                setUnselectedRows([]);
                                setFilter('');
                            }}
                        />
                    }
                </Grid>

                <Grid item>
                    {
                        selectedRows.length > 0 &&
                        <Button
                            type="icon"
                            icon="settings"
                            disabled={!selectedRows.length}
                            tooltip={messages['map_landmark_bulk_actions']}
                            size="medium"
                            fontSize="inherit"
                            onClick={() => {
                                dispatch(mapGeofenceBulkOpenModal(true, selectedRows));
                                setSelectedRows([]);
                                setFilter('');
                            }}
                        />
                    }
                </Grid>
            </Grid>

            {loadingGeofenceJson && <LinearProgress />}
            <InfiniteScroll
                dataLength={data.length}
                height={550}
                next={() => {
                    if (!filter) { //when the user not filter de data
                        setNoPage(page + 1);
                    }
                }}
                hasMore={(jsonGeofence.length > data.length)}
                loader={<span />}
                endMessage={""}
            >
                <Grid
                    container
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                >
                    {
                        data.map((row, index) => {
                            let selected = selectedRows.find(selectedRow => selectedRow.id === row.id);

                            const valueRadius = row?.radius
                            let geofenceRadius = GeofenceRadiusValues.find(value => value.value == valueRadius)?.text;
                            geofenceRadius = geofenceRadius ? geofenceRadius : `${isKph ? parseFloat(valueRadius * 0.001).toFixed(2) : parseFloat(valueRadius * 0.000621371).toFixed(2)} ${isKph ? messages['kilometers'] : messages['miles']}`;

                            return (
                                <Grid
                                    key={index}
                                    item
                                    xs
                                    style={{
                                        width: '100%',
                                        margin: 0
                                    }}
                                >
                                    <div style={{ padding: '10px 15px 10px 1px' }}>
                                        <div className={selected ? "lSettingsView-card lSettingsView-container-selected" : "lSettingsView-card lSettingsView-container"}>
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="flex-start"
                                                alignItems="center"
                                            >
                                                <Grid item>
                                                    <Checkbox
                                                        id={'checked_' + row?.id}
                                                        value={selected ? true : false}
                                                        size="sm"
                                                        onChange={(checked) => {
                                                            selectRow(row, checked);
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item>
                                                    <Icon style={{ width: 20, height: 20, color: `#${getIconGeofence(row)}` }}
                                                        className="lSetting-start-icon" >
                                                        square
                                                    </Icon>
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs
                                                    zeroMinWidth
                                                    style={{
                                                        paddingRight: 20
                                                    }}
                                                >
                                                    <Typography
                                                        noWrap
                                                        variant="subtitle1"
                                                        className="lSetting-title"
                                                        onClick={() => onSelectCard(row)} //implement select card
                                                    >
                                                        {row?.name}
                                                    </Typography >
                                                </Grid>

                                                <Grid item style={{ position: 'relative' }}>
                                                    <MenuComponent
                                                        disabled={loadingGeofenceJson || geofenceTagsLoading}
                                                        options={landmarkActions}
                                                        icon={'more_vert'}
                                                        className="lSetting-actions icon-menu-vehicle-service showInHover"
                                                        onClick={(type) => {
                                                            if (type === messages['map_landmark_edit']) {
                                                                //findGeofenceOnMap(row);
                                                                dispatch(mapGeofencesOpenEditCreateModal(true, row.id));
                                                            } else if (type === messages['map_landmark_delete']) {
                                                                dispatch(mapGeofenceOpenDeleteModal(true, [row]));
                                                            }
                                                            setFilter('');
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>

                                            {
                                                row?.radius > 0 &&
                                                <Grid
                                                    container
                                                    wrap="nowrap"
                                                    direction="row"
                                                    justifyContent="flex-start"
                                                    alignItems="center"
                                                    onClick={() => onSelectCard(row)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <Grid item xs={4}>
                                                        <Typography noWrap variant="subtitle2" color={row?.id == selectedRow?.id ? 'inherit' : 'textSecondary'}>
                                                            {`${messages['mapGeofenceSettings_geofence_radius']}:`}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={8}>
                                                        <Typography
                                                            className="lSetting-detail"
                                                            noWrap
                                                            variant="subtitle2"
                                                            color={row?.id == selectedRow?.id ? 'inherit' : 'textSecondary'}
                                                        >
                                                            {geofenceRadius}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            }

                                            <Grid
                                                container
                                                wrap="nowrap"
                                                direction="row"
                                                justifyContent="flex-start"
                                                alignItems="center"
                                                onClick={() => onSelectCard(row)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <Grid item xs={4}>
                                                    <Typography noWrap variant="subtitle2" color={row?.id == selectedRow?.id ? 'inherit' : 'textSecondary'}>
                                                        {messages['mapGeofenceSettings_geofence_group']}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <TagsGroup
                                                        options={convertTagStringToArray(row)}
                                                        nameField="name"
                                                        colorField="color"
                                                    />
                                                </Grid>
                                            </Grid>

                                            {
                                                row?.isAlert > 0 &&
                                                <Grid
                                                    container
                                                    wrap="nowrap"
                                                    direction="row"
                                                    justifyContent="flex-start"
                                                    alignItems="center"
                                                    //onClick={() => onSelectCard(row)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <Grid item xs={4}>
                                                        <Typography noWrap variant="subtitle2" color={row?.id == selectedRow?.id ? 'inherit' : 'textSecondary'}>
                                                            {`${messages['mapGeofenceSettings_geofence_alerton']}:`}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={8}>
                                                        <Grid
                                                            container
                                                            direction="row"
                                                            justifyContent="center"
                                                            alignItems="center"
                                                        >
                                                            <Grid item xs={4}>
                                                                <Typography className="lSetting-detail" noWrap variant="subtitle2" color={row?.id == selectedRow?.id ? 'inherit' : 'textSecondary'}>
                                                                    {row?.alertOnType}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                <Typography className="lSetting-detail" noWrap variant="subtitle2" color={row?.id == selectedRow?.id ? 'inherit' : 'textSecondary'} style={{ fontSize: 12 }} >
                                                                    {row?.insideDurationMins > 0 &&
                                                                        <ScheduleIcon style={{ fontSize: 12 }} />
                                                                    }

                                                                    {row?.insideDurationFormat}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                <Tooltip position="top" title={messages['mapGeofenceSettings_geofence_contacts']}>
                                                                    <Grid
                                                                        container
                                                                        direction="row"
                                                                        justifyContent="center"
                                                                        alignItems="center"
                                                                    >
                                                                        <Grid item>
                                                                            <Icon style={{ fontSize: 16, marginTop: 5 }}>person</Icon>
                                                                        </Grid>
                                                                        <Grid item>
                                                                            <Typography
                                                                                noWrap
                                                                                style={{ textDecoration: 'underline', color: '#04a9f4' }}
                                                                                onClick={() => {
                                                                                    dispatch(mapGeofencesOpenContactsModal(true, row.id));
                                                                                    setFilter('');
                                                                                }}
                                                                            >
                                                                                ({onCountContacts(row?.contacts)})
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Tooltip>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            }

                                            <Grid
                                                container
                                                wrap="nowrap"
                                                direction="row"
                                                justifyContent="flex-start"
                                                alignItems="center"
                                                //onClick={() => onSelectCard(row)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <Grid item xs={4}>
                                                    <Typography noWrap variant="subtitle2" color={row?.id == selectedRow?.id ? 'inherit' : 'textSecondary'}>
                                                        {`${messages['mapGeofenceSettings_geofence_units']}:`}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <Typography
                                                        className="lSetting-detail"
                                                        noWrap variant="subtitle2"
                                                        style={{ textDecoration: 'underline', color: '#04a9f4' }}
                                                        onClick={() => {
                                                            dispatch(mapGeofencesOpenCloseAssignModal(true, row?.id, "geofence"));
                                                            setFilter('');
                                                        }}
                                                    >
                                                        {`${row?.assignedUnitsCount || 0} (${messages['mapGeofenceSettings_geofence_manage']})`}
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                        </div>
                                    </div>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </InfiniteScroll>

            {openContacts && <Contacts />}
            <Delete cleanSearch={cleanSearch} />
            {openAssign && <GeofenceAssign callback={() => dispatch(getKmls())} />}

            {   //Create the object when user open the modal
                openGeofenceBulk
                &&
                <GeofenceBulk mapRef={mapRef} />
            }

        </div>
    )
}

export default injectIntl(GeofenceSettingsViewGeo);